var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZeste(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3701 73.82C22.3701 73.82 13.6701 55.63 10.9601 49.25C8.22009 42.8 0.590088 22.49 0.590088 22.49C0.590088 22.49 18.3501 13.75 24.6701 11.06C31.1701 8.30002 51.9101 0.710022 51.9101 0.710022C51.9101 0.710022 62.0801 20.6 64.7501 26.88C67.5301 33.43 73.7001 52.03 73.7001 52.03C73.7001 52.03 54.7201 62.55 48.2101 65.31C41.8901 68 22.3701 73.82 22.3701 73.82Z",
    fill: "#002FA7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9601 74C52.9601 74 33.9401 65.13 27.4901 62.59C20.9701 60.02 1.09009 53.53 1.09009 53.53C1.09009 53.53 9.98009 34.46 12.5001 28.06C15.0901 21.49 21.5601 1.66003 21.5601 1.66003C21.5601 1.66003 40.6801 10.57 47.0301 13.07C53.6501 15.68 73.4301 22.13 73.4301 22.13C73.4301 22.13 64.6101 41.03 62.0201 47.6C59.4901 54 52.9601 74 52.9601 74Z",
    fill: "#182C77"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.46 69.43C54.9564 69.43 69.14 55.2464 69.14 37.75C69.14 20.2536 54.9564 6.07001 37.46 6.07001C19.9636 6.07001 5.78003 20.2536 5.78003 37.75C5.78003 55.2464 19.9636 69.43 37.46 69.43Z",
    fill: "#E0A648"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M37.4599 65.77C52.935 65.77 65.4799 53.225 65.4799 37.75C65.4799 22.275 52.935 9.72998 37.4599 9.72998C21.9849 9.72998 9.43994 22.275 9.43994 37.75C9.43994 53.225 21.9849 65.77 37.4599 65.77Z",
    fill: "#FFF3E4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5702 60.05C48.5702 60.05 46.8302 59.72 44.8502 57.57C42.2002 54.7 38.3002 43.28 40.4902 41.41C42.6402 39.58 52.1902 44.78 54.7602 47.66C56.7702 49.91 57.2402 52.62 57.2402 52.62C57.2402 52.62 55.9802 56.63 54.6002 57.91C53.2302 59.18 48.5702 60.05 48.5702 60.05Z",
    fill: "#E0A648"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.27 60.05C26.27 60.05 25.88 57.99 26.27 55.09C26.79 51.22 33.43 41.95 36.26 42.45C39.04 42.94 41.71 55 41.14 58.81C40.69 61.79 39.9 62.53 39.9 62.53C39.9 62.53 34.33 64.02 32.47 63.77C30.61 63.52 26.27 60.05 26.27 60.05Z",
    fill: "#E0A648"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6401 43.94C12.6401 43.94 13.7501 41.54 16.3601 40.22C19.8401 38.46 31.5601 37.19 32.7601 39.81C33.9301 42.38 26.0301 50.93 22.5601 52.61C19.8501 53.93 17.6001 52.61 17.6001 52.61C17.6001 52.61 14.7301 50.57 13.8801 48.89C13.0301 47.21 12.6401 43.94 12.6401 43.94Z",
    fill: "#E0A648"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6001 22.88C17.6001 22.88 19.8301 23.09 22.5601 24.12C26.2101 25.5 33.7101 32.81 32.5901 35.46C31.4901 38.06 19.9501 37.93 16.3701 36.51C13.5701 35.4 12.6501 32.79 12.6501 32.79C12.6501 32.79 11.9301 28.8 12.5901 27.05C13.2401 25.29 17.6001 22.88 17.6001 22.88Z",
    fill: "#E0A648"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.42 12.97C37.42 12.97 39.1 15.12 39.9 17.93C40.97 21.68 38.94 31.83 36.15 32.51C33.4 33.18 27.27 25.37 26.27 21.65C25.49 18.74 26.27 15.46 26.27 15.46C26.27 15.46 29.42 12.26 31.23 11.74C33.03 11.21 37.42 12.97 37.42 12.97Z",
    fill: "#E0A648"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2501 21.64C57.2501 21.64 57.7501 24.25 56.0101 26.6C53.6801 29.73 42.7201 35.3 40.4801 33.49C38.2801 31.71 42.5001 20.98 44.8601 17.92C46.7001 15.53 47.3401 15.44 47.3401 15.44C47.3401 15.44 52.5801 15.46 54.0901 16.57C55.5901 17.7 57.2501 21.64 57.2501 21.64Z",
    fill: "#E0A648"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2 42.71C62.2 42.71 60.16 43.76 57.24 43.95C53.35 44.2 42.44 40.43 42.37 37.55C42.3 34.72 53.39 30.51 57.24 30.32C60.25 30.18 62.2 31.56 62.2 31.56C62.2 31.56 63.94 35.08 64.07 36.96C64.19 38.82 62.2 42.71 62.2 42.71Z",
    fill: "#E0A648"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M34.9301 39.01C34.4801 37.83 33.6401 36.63 34.2901 35.65C34.7201 35 35.4201 35.5 36.2001 35.21C37.2401 34.82 38.2601 33.89 39.1801 34.35C40.0001 34.76 40.6801 35.48 41.0301 36.4C41.4901 37.62 40.7101 38.01 40.0101 39.01C39.5901 39.61 39.5601 41.02 38.8201 41.3C38.1401 41.56 37.4201 41.61 36.7501 41.47C35.4901 41.24 35.4101 40.29 34.9301 39.01Z",
    fill: "#FFF3E4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M53.0601 38.13C52.7701 38.13 43.0901 37.98 43.0901 37.76C43.0901 37.54 52.7701 37.35 53.0601 37.35C53.3501 37.35 53.5801 37.52 53.5801 37.74C53.5801 37.96 53.3501 38.13 53.0601 38.13Z",
    fill: "#FFF3E4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M47.33 50.14C47.15 49.92 41.17 42.3 41.34 42.16C41.51 42.02 47.75 49.42 47.93 49.65C48.11 49.87 48.12 50.17 47.96 50.3C47.8 50.43 47.52 50.37 47.33 50.14Z",
    fill: "#FFF3E4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M48.2401 25.25C48.0501 25.47 41.5901 32.68 41.4301 32.54C41.2701 32.4 47.4601 24.96 47.6501 24.74C47.8401 24.52 48.1201 24.46 48.2901 24.6C48.4501 24.74 48.4301 25.03 48.2401 25.25Z",
    fill: "#FFF3E4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M22.09 31.16C22.36 31.26 31.42 34.68 31.35 34.88C31.28 35.08 22.1 31.99 21.83 31.9C21.56 31.8 21.4 31.56 21.47 31.36C21.54 31.15 21.82 31.06 22.09 31.16Z",
    fill: "#FFF3E4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M22.16 44.27C22.42 44.14 31.2 40.06 31.29 40.25C31.38 40.44 22.76 44.84 22.5 44.97C22.24 45.1 21.95 45.04 21.86 44.85C21.77 44.66 21.9 44.4 22.16 44.27Z",
    fill: "#FFF3E4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M33.6001 53.37C33.6501 53.09 35.6201 43.61 35.8301 43.65C36.0401 43.69 34.4201 53.23 34.3601 53.52C34.3101 53.8 34.0901 54 33.8801 53.96C33.6701 53.92 33.5401 53.65 33.6001 53.37Z",
    fill: "#FFF3E4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M34.0501 21.08C34.1101 21.36 35.9301 30.87 35.7201 30.92C35.5101 30.97 33.3501 21.53 33.2901 21.24C33.2301 20.96 33.3501 20.69 33.5601 20.65C33.7701 20.6 33.9901 20.8 34.0501 21.08Z",
    fill: "#FFF3E4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeste);
export default __webpack_public_path__ + "static/media/zeste.5daaaff172a4a1fca14c52661ac30348.svg";
export { ForwardRef as ReactComponent };